import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./WeddingPackage.css";
import Navber from "../Home/Common_navber.jsx";
import WeddingIntroSection from "../Home/WeddingIntroSection.jsx";
import api from "../../Api.js";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";

const WeddingPackages = () => {
  const [PackagesData, setPackagesData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await api.get("banquet-events");
        setPackagesData(response?.data?.data || []);
        console.log("Fetched packages:", response.data.data);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };
    fetchPackages();
  }, []);

  return (
    <>
      <Navber />
      <section className="wpkg-section" id="packages">
        <motion.h2
          className="wpkg-title"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          Our Wedding Packages
        </motion.h2>

        <motion.p
          className="wpkg-subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Choose the perfect package to make your special day unforgettable.
        </motion.p>

        <div className="wpkg-container">
          {PackagesData.map((pkg, index) => (
            <motion.div
              className="wpkg-card"
              key={pkg.id || index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03 }}
            >
              {/* 🏷️ Header */}
              <div className="wpkg-card-header">
                <h3 className="wpkg-card-title">{pkg.event_type}</h3>
                <span className="wpkg-card-subtitle">{pkg.event_name}</span>
                <div className="wpkg-price-box">
                  <h2 className="wpkg-price">₹{pkg.price}</h2>
                  <span className="wpkg-small-text">(Starting Price)</span>
                </div>
              </div>

              {/* 📍 Additional Details */}
              <div className="wpkg-details">
                <p>
                  <strong>📍 Location:</strong> {pkg.location || "Not specified"}
                </p>
                <p>
                  <strong>📏 Plot Size:</strong>{" "}
                  {pkg.plot_size ? `${pkg.plot_size} sq.ft` : "N/A"}
                </p>
                {/* <p>
                  <strong>📅 Added On:</strong>{" "}
                  {pkg.created_at
                    ? new Date(pkg.created_at).toLocaleDateString()
                    : "N/A"}
                </p> */}
              </div>

              {/* 🌸 Sanitized HTML Feature List */}
              <div
                className="wpkg-feature-list"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(pkg.event_feature || ""),
                }}
              ></div>

              {/* 🎟️ Button */}
              <div className="wpkg-btn-wrapper">
                <motion.button
                  className="wpkg-book-btn"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={()=>navigate(`/packages/${pkg?.id}`)}
                >
                  Book Now
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <WeddingIntroSection />
    </>
  );
};

export default WeddingPackages;
